{
  "page": {
    "intro": "ตั้งค่าภาษีของร้าน: 10% ที่รวมอยู่ในทุกราคา, 登録番号 บนใบเสร็จ, ออเดอร์ต่างประเทศ และการขายปลอดภาษี ตัวอย่างด้านขวาแสดงผลทันที",
    "load_failed": "โหลดการตั้งค่าภาษีไม่ได้"
  },
  "tabs": {
    "label": "หน้าภาษี",
    "settings": "ตั้งค่า",
    "calendar": "วันที่ตามกฎหมาย",
    "tax_free": "ขายปลอดภาษี (免税)",
    "report": "รายงานรายเดือน",
    "documents": "ค้นหาเอกสาร"
  },
  "jct": {
    "title": "ภาษีการบริโภค (消費税)",
    "intro": "ราคาในร้านรวมภาษี 10% เสมอ (税込) ภาษีคำนวณครั้งเดียวต่อใบเสร็จ",
    "rate": "อัตราภาษี",
    "rate_value": "{{rate}}% — รวมอยู่ในทุกราคา",
    "rate_help": "กฎหมายญี่ปุ่นให้แสดงราคารวมภาษี (総額表示) อัตรานี้ตายตัว เปลี่ยนที่นี่ไม่ได้",
    "rate_note": "กำหนดโดยกฎหมาย — เท่ากันทุกการ์ดและทุกกล่อง",
    "rounding": "การปัดเศษ",
    "rounding_per_document_floor": "ครั้งเดียวต่อใบเสร็จ ปัดลง",
    "rounding_per_document_round_half_up": "ครั้งเดียวต่อใบเสร็จ ปัดใกล้สุด",
    "rounding_per_document_ceil": "ครั้งเดียวต่อใบเสร็จ ปัดขึ้น",
    "rounding_help": "กฎ インボイス ให้ปัดเศษได้ครั้งเดียวต่อใบเสร็จต่ออัตรา ร้านใช้ปัดลง",
    "rounding_note": "ใบเสร็จที่ออกไปแล้วยังใช้วิธีปัดเดิม",
    "registration": "เลขทะเบียน (登録番号)",
    "registration_help": "เลขของร้านในฐานะผู้ออกใบกำกับภาษี: ตัว T ตามด้วยตัวเลข 13 หลัก พิมพ์บนทุกใบเสร็จ",
    "registration_hint": "ตรวจเลขนี้ที่เว็บ 国税庁 公表サイト ก่อนบันทึก",
    "registration_placeholder": "นี่คือเลขตัวอย่าง — ใส่ 登録番号 จริงของร้าน",
    "registration_format": "登録番号 ต้องเป็น T ตามด้วยตัวเลข 13 หลัก",
    "business_name_ja": "ชื่อธุรกิจ (ญี่ปุ่น)",
    "business_name_en": "ชื่อธุรกิจ (อังกฤษ)",
    "business_name_help": "ชื่อที่จดทะเบียนกับ 登録番号 พิมพ์บนใบเสร็จ",
    "tax_office": "สำนักงานภาษี (税務署)",
    "tax_office_help": "สำนักงานภาษีที่ร้านยื่นแบบ",
    "fiscal_year": "ปีภาษีเริ่มเดือน",
    "fiscal_year_help": "เดือนแรกของปีภาษีของร้าน",
    "month": "เดือน {{month}}",
    "business_type": "ผู้ดำเนินกิจการ",
    "business_type_help": "บริษัทหรือบุคคลธรรมดา (個人事業者) กฎพิเศษบางข้อใช้ได้เฉพาะบุคคล",
    "business_corporation": "บริษัท (法人)",
    "business_individual": "บุคคลธรรมดา (個人事業者)",
    "method": "วิธีรวมภาษีขาย",
    "method_help": "割戻し รวมยอดขายก่อน ส่วน 積上げ รวมภาษีที่พิมพ์ในแต่ละใบเสร็จ เลือกร่วมกับนักบัญชี",
    "method_warimodoshi": "割戻し計算",
    "method_warimodoshi_desc": "คิดภาษีจากยอดขายรวมของเดือน",
    "method_tsumiage": "積上げ計算",
    "method_tsumiage_desc": "รวมภาษีของแต่ละใบเสร็จ",
    "ask_accountant": "ปรึกษา 税理士",
    "simplified": "ภาษีแบบง่าย (簡易課税)",
    "simplified_desc": "เฉพาะช่วงที่สำนักงานภาษีรับแจ้งแล้ว",
    "simplified_help": "วิธีคิดภาษีแบบง่ายสำหรับธุรกิจเล็ก ต้องมีวันเริ่มและวันสิ้นสุด",
    "simplified_from": "ภาษีแบบง่ายตั้งแต่",
    "simplified_to": "ภาษีแบบง่ายถึง",
    "small_business": "กฎพิเศษธุรกิจขนาดเล็ก",
    "small_business_help": "2割特例 และ 3割特例 ลดภาษีที่ต้องจ่ายไม่กี่ปี วันที่ตามกฎหมายบอกว่าสิ้นสุดเมื่อไร",
    "small_none": "ไม่ใช้",
    "small_2wari": "2割特例",
    "small_2wari_ended": "กฎนี้สิ้นสุดแล้ว",
    "small_3wari": "3割特例",
    "small_3wari_desc": "เฉพาะบุคคลธรรมดา ในปีที่กฎหมายอนุญาต",
    "small_3wari_not_now": "ใช้ไม่ได้ในวันนี้",
    "small_until": "ถึง {{date}}",
    "credit": "รับซื้อจากคนที่ไม่มี 登録番号",
    "credit_help": "เมื่อร้านรับซื้อการ์ดจากคนที่ไม่มี 登録番号 หักภาษีซื้อได้เพียงบางส่วน กฎหมายลดลงเป็นขั้น",
    "credit_value": "หักภาษีได้ {{rate}}% (ไม่เกิน {{cap}} ต่อคนต่อปี)",
    "credit_next": "เปลี่ยนเป็น {{rate}}% วันที่"
  },
  "export": {
    "title": "ออเดอร์ต่างประเทศ",
    "intro": "การ์ดที่ส่งไปต่างประเทศขายได้โดยไม่มีภาษี 10% (輸出免税) ถ้าร้านเก็บหลักฐานไว้",
    "policy": "ราคาสำหรับลูกค้าต่างประเทศ",
    "policy_help": "ถอดภาษีออกจากราคาปกติ หรือใช้ราคาแยกตามตลาด",
    "strip_tax": "ถอดภาษีออก (税抜で販売)",
    "strip_tax_example": "การ์ดราคา {{price}} ขายต่างประเทศ {{base}}",
    "market_price": "ตั้งราคาต่างประเทศแยก",
    "market_price_desc": "แต่ละตลาดมีราคาของตัวเอง (ตั้งใน Markets)",
    "evidence_required": "เก็บหลักฐานส่งออกทุกออเดอร์ต่างประเทศ",
    "evidence_required_desc": "หน้าออเดอร์จะขอหลักฐานการส่งจนกว่าจะเก็บครบ",
    "evidence_help": "ถ้าไม่มีหลักฐาน การขายนั้นนับเป็นการขายในญี่ปุ่นที่มีภาษี 10%",
    "postal_limit": "เพดานส่งไปรษณีย์โดยไม่ต้องมีใบอนุญาตส่งออก",
    "postal_limit_help": "ไม่เกินมูลค่านี้ต่อกล่อง ใช้บันทึกรับฝากของไปรษณีย์ + สำเนาใบส่งก็พอ เกินกว่านี้ต้องมีใบอนุญาตส่งออก (輸出許可書)",
    "postal_limit_hint": "กฎหมายวันนี้กำหนด ¥200,000",
    "block_cash": "ไม่รับเงินสดสำหรับออเดอร์ต่างประเทศ",
    "block_cash_desc": "เงินสดพิสูจน์ไม่ได้ว่าใครจ่าย จึงไม่รับสำหรับการขายส่งออกปลอดภาษี"
  },
  "taxfree": {
    "title": "ขายปลอดภาษีให้นักท่องเที่ยว (免税)",
    "intro": "เฉพาะหน้าร้าน และต้องมีใบอนุญาต 輸出物品販売場",
    "licensed": "ร้านมีใบอนุญาต 輸出物品販売場",
    "licensed_desc": "เปิดการขายปลอดภาษีที่หน้าร้าน",
    "licensed_help": "ใบอนุญาตจากสำนักงานภาษีที่ให้ขายปลอดภาษีแก่นักท่องเที่ยว",
    "license_granted_on": "วันที่ในใบอนุญาต (許可年月日)",
    "license_granted_on_help": "วันที่ที่เขียนในใบอนุญาตจากสำนักงานภาษี ระบบใช้ดูว่าเป็นใบอนุญาตก่อนหรือหลังระบบใหม่",
    "filing": "วันที่ยื่นแจ้งแบบอิเล็กทรอนิกส์ (電子化届出)",
    "filing_help": "ร้านที่มีใบอนุญาตต้องยื่น 電子化届出 มิฉะนั้นใบอนุญาตสิ้นผล",
    "filing_deadline": "ยังไม่ได้ทำ — เหลือ {{days}} วัน กำหนด",
    "regime_now": "ระบบปลอดภาษีวันนี้",
    "regime": {
      "exemption": "免税価格方式 — นักท่องเที่ยวจ่ายราคาไม่รวมภาษี",
      "refund": "リファンド方式 — นักท่องเที่ยวจ่ายราคาเต็ม แล้วได้ภาษีคืนหลังศุลกากรยืนยัน"
    },
    "regime_switch": "เปลี่ยนเป็น リファンド方式 อีก {{days}} วัน วันที่",
    "regime_unknown": "อ่านวันที่ตามกฎหมายไม่ได้ในตอนนี้",
    "regime_overridden": "ร้านตั้งเองด้วยมือ — ไม่ได้ตามวันที่ตามกฎหมาย",
    "regime_refund_explain": "แบบ リファンド方式 ร้านคืนภาษีเองเมื่อศุลกากรยืนยันว่านักท่องเที่ยวนำของออกนอกประเทศ (ภายใน 90 วัน)",
    "override": "ตามวันที่ตามกฎหมาย",
    "override_help": "ให้เป็น \"อัตโนมัติ\" ไว้ เลือกเองเฉพาะเมื่อสำนักงานภาษีสั่ง",
    "override_auto": "อัตโนมัติ",
    "override_auto_desc": "เปลี่ยนเองตามวันที่ตามกฎหมาย",
    "override_warning": "ไม่มีช่วงที่ใช้สองระบบพร้อมกัน ใช้เฉพาะเมื่อสำนักงานภาษีสั่ง",
    "exemption_ended": "ระบบเดิม (หักภาษีที่เคาน์เตอร์) สิ้นสุดแล้ว ตอนนี้ใช้แบบคืนภาษีเท่านั้น — เลือก “อัตโนมัติ” แล้วบันทึก",
    "min_amount": "ยอดซื้อขั้นต่ำที่ปลอดภาษี",
    "min_amount_help": "ต่ำกว่ายอดนี้ (ไม่รวมภาษี) ขายปลอดภาษีไม่ได้",
    "high_value": "ต้องมีเลขซีเรียลตั้งแต่",
    "high_value_help": "สินค้าราคาเท่านี้ขึ้นไปต้องบันทึกเลขซีเรียลหรือเลขใบเกรด",
    "sender_id": "รหัสผู้ส่ง (送信者識別符号)",
    "sender_id_help": "ได้จากสำนักงานภาษีสำหรับส่ง 購入記録情報",
    "store_id": "รหัสร้าน (販売場識別符号)",
    "store_id_help": "รหัสของร้านนี้ในฐานะร้านปลอดภาษี",
    "cert": "อ้างอิงใบรับรองการส่ง",
    "cert_replace": "อ้างอิงใบรับรองใหม่",
    "cert_help": "ที่เก็บใบรับรองสำหรับการส่ง แสดงเฉพาะ 4 ตัวท้าย",
    "cert_hint": "เว้นว่างไว้ = ใช้ของที่บันทึกไว้",
    "refund_provider": "ใครคืนภาษี",
    "refund_provider_help": "ร้านเอง หรือบริษัทรับคืนภาษี",
    "provider_self": "ร้านเอง",
    "provider_self_desc": "พนักงานโอนเงินหลังศุลกากรยืนยัน",
    "provider_agent": "บริษัทรับคืนภาษี",
    "provider_agent_desc": "บริษัทจ่ายให้นักท่องเที่ยวแทนร้าน",
    "agent_name": "ชื่อบริษัทรับคืนภาษี",
    "self_refund_warning": "การคืนเงินให้คนต่างประเทศอาจต้องมีใบอนุญาต (資金移動業) ปรึกษา 税理士 หรือ 行政書士 ก่อน",
    "refund_method": "วิธีคืนเงินที่ใช้ปกติ",
    "refund_method_help": "เลือกได้ทุกครั้งที่คืน นี่คือตัวเลือกแรก",
    "files_now": "ระหว่างที่ยังไม่เชื่อมกับสำนักงานภาษี ไฟล์ 購入記録情報 สร้างได้ในหน้าขายปลอดภาษี",
    "records_link": "เปิดหน้าขายปลอดภาษี"
  },
  "refund_method": {
    "bank_transfer": "โอนธนาคาร",
    "cash_agent": "เงินสดผ่านตัวแทน",
    "agent_company": "บริษัทรับคืนภาษี",
    "stripe_refund": "คืนเข้าบัตร",
    "stripe_later": "มาพร้อมการเชื่อมบัตร"
  },
  "advanced": {
    "title": "สำหรับนักบัญชี",
    "intro": "ค่าที่เจ้าของร้านตั้งครั้งเดียวร่วมกับ 税理士",
    "journal": "การลงบัญชีการขายปลอดภาษี",
    "journal_help": "จังหวะที่ย้ายการขายจากมีภาษีเป็นปลอดภาษีในบัญชี",
    "journal_per_record": "ทุกการขาย",
    "journal_monthly": "เดือนละครั้ง",
    "consigned": "การ์ดฝากขาย",
    "consigned_help": "นับภาษีของการ์ดที่เป็นของบุคคลอย่างไร",
    "consigned_out_of_scope": "คิดภาษีเฉพาะค่าธรรมเนียมร้าน",
    "consigned_out_of_scope_desc": "ใบเสร็จแสดง 委託品／インボイス対象外",
    "consigned_gross": "คิดภาษีทั้งราคา",
    "consigned_gross_desc": "ใช้เฉพาะเมื่อนักบัญชีบอก",
    "commission_tax": "ค่าธรรมเนียมร้านรวมภาษี",
    "commission_tax_desc": "ค่าธรรมเนียมฝากขายเป็นยอด 税込"
  },
  "preview": {
    "title": "ตัวอย่าง",
    "updating": "กำลังอัปเดตตัวอย่าง",
    "loading": "กำลังโหลดตัวอย่าง…",
    "owner_only": "ตัวอย่างนี้เห็นได้เฉพาะเจ้าของร้าน",
    "domestic": "ขายในญี่ปุ่น",
    "export": "ส่งต่างประเทศ",
    "taxfree": "ปลอดภาษีหน้าร้าน",
    "price": "ราคา",
    "base": "ไม่รวมภาษี",
    "tax": "ภาษี {{rate}}%",
    "tax_zero": "ภาษี 0%",
    "customer_pays": "ลูกค้าจ่าย",
    "export_market": "ใช้ราคาที่ตั้งไว้สำหรับตลาดของลูกค้า",
    "refund_after_customs": "คืนหลังศุลกากร",
    "taxfree_exemption_note": "นักท่องเที่ยวจ่ายราคาไม่รวมภาษีที่หน้าร้าน",
    "taxfree_refund_note": "ร้านคืนภาษีเมื่อศุลกากรยืนยัน (ภายใน 90 วัน)",
    "rounding_per_document_floor": "คิดภาษีครั้งเดียวต่อใบเสร็จ ปัดลง",
    "rounding_per_document_round_half_up": "คิดภาษีครั้งเดียวต่อใบเสร็จ ปัดใกล้สุด",
    "rounding_per_document_ceil": "คิดภาษีครั้งเดียวต่อใบเสร็จ ปัดขึ้น"
  },
  "save": {
    "button": "บันทึก",
    "changes_other": "เปลี่ยน {{count}} รายการ",
    "no_changes": "ไม่มีการเปลี่ยน",
    "effective_from": "ใช้ตั้งแต่",
    "effective_from_hint": "ว่าง = ตั้งแต่พรุ่งนี้ ใช้วันนี้ได้เฉพาะเมื่อวันนี้ยังไม่ได้ออกใบเสร็จ",
    "confirm_title": "บันทึกการตั้งค่าภาษีไหม?",
    "confirm_from": "ใบเสร็จทุกใบตั้งแต่ {{date}} ใช้ค่าใหม่",
    "confirm_tomorrow": "ใบเสร็จทุกใบตั้งแต่พรุ่งนี้ใช้ค่าใหม่",
    "confirm": "บันทึก",
    "saved": "บันทึกแล้ว — ใช้ตั้งแต่ {{date}}",
    "replaced": "บันทึกแล้ว — แทนที่การเปลี่ยนที่วางไว้วันที่ {{date}}",
    "scheduled": "กำลังดูการเปลี่ยนที่วางไว้ (เวอร์ชัน {{version}}) ใช้ตั้งแต่",
    "read_only": "คุณดูการตั้งค่านี้ได้ เปลี่ยนได้เฉพาะเจ้าของร้าน"
  },
  "fields": {
    "invoiceRegistrationNumber": "เลขทะเบียน (登録番号)",
    "businessNameJa": "ชื่อธุรกิจ (ญี่ปุ่น)",
    "businessNameEn": "ชื่อธุรกิจ (อังกฤษ)",
    "storeNameEn": "ชื่อร้าน (อังกฤษ)",
    "taxOffice": "สำนักงานภาษี",
    "businessType": "ผู้ดำเนินกิจการ",
    "fiscalYearStartMonth": "เดือนเริ่มปีภาษี",
    "salesTaxMethod": "วิธีรวมภาษีขาย",
    "simplifiedTaxationFlag": "ภาษีแบบง่าย",
    "simplifiedTaxationFrom": "ภาษีแบบง่ายตั้งแต่",
    "simplifiedTaxationTo": "ภาษีแบบง่ายถึง",
    "smallBusinessSpecial": "กฎพิเศษธุรกิจขนาดเล็ก",
    "exportPricingPolicy": "ราคาสำหรับลูกค้าต่างประเทศ",
    "exportEvidenceRequired": "เก็บหลักฐานส่งออก",
    "exportBlockCash": "ไม่รับเงินสดออเดอร์ต่างประเทศ",
    "postalExportLimit": "เพดานส่งไปรษณีย์",
    "taxFreeLicensed": "ใบอนุญาตปลอดภาษี",
    "electronicFilingDoneAt": "ยื่นแบบอิเล็กทรอนิกส์",
    "taxFreeRegimeOverride": "ระบบปลอดภาษี (ตั้งเอง)",
    "clearTaxFreeRegimeOverride": "ระบบปลอดภาษี (อัตโนมัติ)",
    "taxFreeMinAmount": "ยอดขั้นต่ำปลอดภาษี",
    "taxFreeHighValueThreshold": "ต้องมีเลขซีเรียลตั้งแต่",
    "ntaSenderId": "รหัสผู้ส่ง",
    "ntaStoreId": "รหัสร้าน",
    "ntaClientCertRef": "ใบรับรองการส่ง",
    "refundProvider": "ใครคืนภาษี",
    "refundAgentName": "บริษัทรับคืนภาษี",
    "defaultRefundMethod": "วิธีคืนเงินปกติ",
    "journalMode": "การลงบัญชีการขายปลอดภาษี",
    "consignedIndividualTreatment": "การ์ดฝากขาย",
    "commissionIncludesTax": "ค่าธรรมเนียมรวมภาษี"
  },
  "issues": {
    "invalid_registration_number": "登録番号 ต้องเป็น T ตามด้วยตัวเลข 13 หลัก",
    "registration_number_placeholder": "นี่คือเลขตัวอย่าง — ใส่ 登録番号 จริงของร้าน",
    "registration_number_unverified": "ตรวจเลขนี้ที่ 国税庁 公表サイト ก่อนให้ลูกค้าเห็น",
    "taxfree_ids_missing": "ร้านปลอดภาษีต้องมีรหัสผู้ส่งและรหัสร้าน (หรือใช้บริษัทรับคืนภาษี)",
    "electronic_filing_pending": "ยังไม่ได้ยื่น 電子化届出 — ถ้าไม่ยื่นใบอนุญาตสิ้นผล",
    "simplified_taxation_dates_required": "ภาษีแบบง่ายต้องมีวันเริ่มและวันสิ้นสุด",
    "wari2_ended": "2割特例 สิ้นสุดแล้วสำหรับวันนี้",
    "wari3_not_allowed": "3割特例 ใช้ได้เฉพาะบุคคลธรรมดาในปีที่กฎหมายอนุญาต",
    "feature_disabled": "การคืนเข้าบัตรมาพร้อมการเชื่อมบัตร — เลือกวิธีอื่น",
    "rounding_change_consistency": "ใบเสร็จที่ออกไปแล้วยังใช้วิธีปัดเดิม",
    "rounding_change_period_boundary": "เปลี่ยนวิธีปัดได้ตั้งแต่ปีภาษีถัดไปเท่านั้น",
    "field_locked": "ค่านี้กำหนดโดยกฎหมาย เปลี่ยนไม่ได้",
    "settings_not_configured": "ยังไม่ได้บันทึกการตั้งค่าภาษี — แสดงค่ามาตรฐาน",
    "taxfree_license_date_missing": "กรุณาใส่วันที่ในใบอนุญาต: ใบอนุญาตก่อนระบบใหม่จะสิ้นผลถ้าไม่ได้ยื่น 電子化届出 ทันกำหนด",
    "taxfree_license_lapsed": "ใบอนุญาตนี้สิ้นผลแล้ว: เป็นใบอนุญาตก่อนระบบใหม่และไม่มีบันทึกการยื่น 電子化届出 ภายในกำหนด ถ้ายื่นแล้วให้ใส่วันที่ยื่น ถ้ายังไม่ได้ยื่นให้ปิดการขายปลอดภาษี",
    "taxfree_refund_completion_missing": "ระบบยังคืนภาษีให้นักท่องเที่ยวไม่ได้ อย่าเพิ่งขายปลอดภาษีจนกว่าจะพร้อม หรือใช้บริษัทรับคืนภาษี",
    "taxfree_refund_override_early": "วิธีคืนภาษี (リファンド方式) เริ่มตามวันในปฏิทินกฎหมาย การใช้ก่อนวันนั้นยังไม่ได้รับการยืนยัน — ถามนักบัญชีภาษีก่อน",
    "other": "โปรดตรวจค่านี้"
  },
  "calendar": {
    "title": "วันที่ตามกฎหมาย",
    "load_failed": "โหลดวันที่ตามกฎหมายไม่ได้",
    "rules_today": "กฎที่ใช้วันนี้",
    "today": "วันนี้",
    "days_left_other": "อีก {{count}} วัน",
    "days_ago_other": "{{count}} วันที่แล้ว",
    "unverified": "ยังไม่ยืนยัน",
    "todo": "สิ่งที่ต้องทำ",
    "source": "แหล่งอ้างอิง",
    "accessed": "ตรวจ {{date}}",
    "mark_done": "ทำแล้ว",
    "done_on": "ทำแล้ววันที่ {{date}}",
    "saved": "บันทึกแล้ว",
    "code": {
      "credit_80_ends": "วันสุดท้ายของการหัก 80%",
      "wari2_ends": "2割特例 สิ้นสุด",
      "credit_70_starts": "หักได้ 70%",
      "taxfree_new_license_open": "เริ่มยื่นขอใบอนุญาตปลอดภาษีใหม่",
      "taxfree_exemption_ends": "วันสุดท้ายของ 免税価格方式 (กำหนดยื่น 電子化届出)",
      "taxfree_refund_starts": "เริ่ม リファンド方式",
      "credit_50_starts": "หักได้ 50%",
      "shogaku_tokurei_ends": "少額特例 สิ้นสุด",
      "credit_30_starts": "หักได้ 30%",
      "credit_0_starts": "หักไม่ได้แล้ว"
    },
    "effect": {
      "credit": "รับซื้อจากคนที่ไม่มี 登録番号: หักภาษีได้ {{rate}}%",
      "wari2_ends": "ใช้ 2割特例 ไม่ได้อีก",
      "taxfree_new_license_open": "ร้านยื่นขอใบอนุญาตปลอดภาษีใหม่ที่สำนักงานภาษีได้",
      "taxfree_exemption_ends": "วันสุดท้ายที่นักท่องเที่ยวจ่ายไม่รวมภาษีที่หน้าร้าน ต้องยื่น 電子化届出 ภายในวันนี้",
      "taxfree_refund_starts": "นักท่องเที่ยวจ่ายราคาเต็ม ร้านคืนภาษีหลังศุลกากรยืนยัน ({{days}} วัน)",
      "shogaku_tokurei_ends": "การซื้อต่ำกว่า ¥10,000 ต้องมีใบกำกับภาษีอีกครั้ง",
      "other": "กฎภาษีเปลี่ยนในวันนี้"
    }
  },
  "alert_action": {
    "review_buylist_credit": "ตรวจราคารับซื้อร่วมกับนักบัญชี",
    "review_small_business_special": "ตรวจกฎพิเศษร่วมกับนักบัญชี",
    "decide_taxfree_licence": "ตัดสินใจว่าจะยื่นขอใบอนุญาตปลอดภาษีไหม",
    "file_electronic_notification": "ยื่น 電子化届出 ที่สำนักงานภาษี",
    "brief_pos_staff_refund_regime": "อธิบายขั้นตอนปลอดภาษีใหม่ให้พนักงานหน้าร้าน",
    "decide_refund_method": "ตัดสินใจวิธีคืนภาษีของร้าน",
    "retry_taxfree_refund": "ลองคืนเงินอีกครั้ง",
    "other": "ตรวจเรื่องนี้กับนักบัญชี"
  },
  "rules": {
    "taxfree_regime": {
      "exemption": "ปลอดภาษี: 免税価格方式 (นักท่องเที่ยวจ่ายไม่รวมภาษี)",
      "refund": "ปลอดภาษี: リファンド方式 (จ่ายเต็ม คืนภาษีหลังศุลกากร)"
    },
    "nonregistered_credit_rate": "รับซื้อจากคนที่ไม่มี 登録番号: หักได้ {{rate}}% ไม่เกิน {{cap}} ต่อคนต่อปี",
    "wari2": {
      "available": "ใช้ 2割特例 ได้",
      "ended": "2割特例 สิ้นสุดแล้ว"
    },
    "shogaku_tokurei": {
      "available": "ซื้อต่ำกว่า ¥10,000 ไม่ต้องมีใบกำกับภาษี (少額特例)",
      "ended": "少額特例 สิ้นสุดแล้ว"
    },
    "wari3": {
      "available_for_individual": "บุคคลธรรมดาใช้ 3割特例 ได้"
    },
    "taxfree_new_license_open": "ยื่นขอใบอนุญาตปลอดภาษีใหม่ได้",
    "regime_overridden": "ตั้งเองเป็น {{override}} (ตามวันที่กฎหมายคือ {{calendar}})",
    "other": "มีกฎภาษีที่ใช้อยู่"
  },
  "records": {
    "title": "ขายปลอดภาษี (免税)",
    "intro": "ทุกการขายปลอดภาษี: การส่งข้อมูลให้สำนักงานภาษี การยืนยันของศุลกากรภายใน 90 วัน และการคืนภาษี",
    "views": "การขายไหน",
    "view": {
      "pending": "รอศุลกากร",
      "due": "ต้องคืนเงิน (ยืนยันแล้ว)",
      "deadline_soon": "เหลือไม่เกิน 7 วัน",
      "send_failed": "ส่งไม่สำเร็จ",
      "failed": "คืนเงินไม่สำเร็จ",
      "refunded": "คืนแล้ว",
      "expired": "หมดเวลา",
      "all": "ทั้งหมด"
    },
    "view_help": {
      "pending": "ศุลกากรยังไม่ยืนยัน เรียงตามกำหนดที่ใกล้สุด",
      "due": "ศุลกากรยืนยันมาเกิน 3 วัน — คืนภาษีตอนนี้",
      "deadline_soon": "ครบ 90 วันภายในหนึ่งสัปดาห์",
      "send_failed": "購入記録情報 ไปไม่ถึงสำนักงานภาษี หรือส่งช้า",
      "failed": "คืนเงินไม่ได้ — ลองอีกครั้งหรือเลือกวิธีอื่น",
      "refunded": "คืนภาษีแล้ว",
      "expired": "ไม่มีผลศุลกากรทันเวลา — การขายยังมีภาษี",
      "all": "ทุกการขายปลอดภาษี ใหม่ก่อน"
    },
    "order": "ออเดอร์",
    "purchased": "วันที่ซื้อ",
    "buyer": "ผู้ซื้อ",
    "base": "ไม่รวมภาษี",
    "tax": "ภาษี",
    "regime": "ระบบ",
    "sent": "ส่งถึงสำนักงานภาษี",
    "late": "ส่งช้า (事後送信)",
    "customs": "ศุลกากร",
    "deadline": "กำหนด",
    "status": "สถานะ",
    "days_left_other": "เหลือ {{count}} วัน",
    "deadline_today": "หมดวันนี้",
    "deadline_passed": "หมดเวลา",
    "search": "ค้นหา",
    "search_placeholder": "เลขออเดอร์หรือเลขติดตาม",
    "empty": "ไม่มีการขายปลอดภาษีตรงนี้"
  },
  "ui_status": {
    "refund_pending": "รอ",
    "refunded": "คืนแล้ว",
    "taxable_final": "ยังมีภาษี",
    "exempted": "ปลอดภาษี",
    "cancelled": "ยกเลิก",
    "failed": "คืนเงินไม่สำเร็จ",
    "written_off": "ปิดแล้ว (雑益)"
  },
  "transmission": {
    "pending": "รอส่ง",
    "exported": "อยู่ในไฟล์",
    "sent": "ส่งแล้ว",
    "accepted": "รับแล้ว",
    "rejected": "ถูกปฏิเสธ",
    "cancelled": "ยกเลิก"
  },
  "transmission_kind": {
    "send": "ส่ง",
    "cancel": "ยกเลิก",
    "resend": "ส่งใหม่"
  },
  "customs": {
    "not_applicable": "ไม่ต้องใช้",
    "pending": "รอ",
    "confirmed": "ยืนยันแล้ว (税関確認済)",
    "denied": "ไม่ยืนยัน",
    "expired": "หมดเวลา"
  },
  "customs_source": {
    "manual": "พนักงานกรอก",
    "csv": "จากไฟล์",
    "nta_api": "จากสำนักงานภาษี"
  },
  "buyer_type": {
    "short_stay": "พำนักระยะสั้น",
    "landing_permit": "ใบอนุญาตขึ้นฝั่ง",
    "jp_nonresident": "คนญี่ปุ่นที่อยู่ต่างประเทศ"
  },
  "goods": {
    "general": "สินค้าทั่วไป",
    "consumable": "สินค้าสิ้นเปลือง"
  },
  "refund_request": {
    "requested": "กำลังส่ง",
    "refunded": "จ่ายแล้ว",
    "failed": "ไม่สำเร็จ",
    "superseded": "ถูกแทนที่"
  },
  "drawer": {
    "title": "ขายปลอดภาษี {{number}}",
    "loading": "กำลังโหลด…",
    "purchased": "ซื้อวันที่",
    "open_order": "เปิดออเดอร์",
    "refund_ready": "ศุลกากรยืนยันแล้ว — คืนภาษีได้ตอนนี้",
    "refund_wait_customs": "คืนเงินได้หลังศุลกากรยืนยันเท่านั้น",
    "refund_closed_expired": "ไม่มีผลศุลกากรทันเวลา — ไม่มีการคืนเงิน",
    "refund_done": "คืนภาษีแล้ว",
    "exemption_note": "免税価格方式: นักท่องเที่ยวจ่ายไม่รวมภาษี ที่นี่ติดตามเฉพาะการส่งข้อมูล",
    "buyer": "ผู้ซื้อ",
    "passport": "หนังสือเดินทาง",
    "passport_hidden": "เลขหนังสือเดินทางแสดงเฉพาะพนักงานที่มีสิทธิ์ตรวจบัตร",
    "passport_show": "แสดง 30 วินาที",
    "passport_hides": "ซ่อนใน {{seconds}} วิ",
    "items": "สินค้า",
    "item": "สินค้า",
    "qty": "จำนวน",
    "serial": "ซีเรียล",
    "total": "รวม",
    "sending": "การส่งให้สำนักงานภาษี",
    "transmission_no": "เลขส่ง {{no}}",
    "customs": "ศุลกากร",
    "checked_at": "ตรวจเมื่อ",
    "manual_until_api": "พนักงานกรอกเองจนกว่าจะเชื่อมกับสำนักงานภาษี",
    "refund_title": "การคืนภาษี",
    "refund_amount": "ภาษีที่ต้องคืน:",
    "refunded_at": "คืนเมื่อ",
    "refund_sending": "กำลังคืนเงิน (วิธีปกติจากการตั้งค่าภาษี) — ขั้นตอนโอนอยู่ในหน้าออเดอร์",
    "retransmit": "ส่งใหม่",
    "resend": "แก้หลังคืนสินค้า (洗替)",
    "confirmed": "ศุลกากรยืนยันแล้ว",
    "denied": "ไม่ปลอดภาษี",
    "write_off": "ปิดโดยไม่คืน",
    "refund": "บันทึกการคืนภาษี",
    "done": {
      "confirmed": "ศุลกากรยืนยันแล้ว — เริ่มคืนเงินแล้ว",
      "denied": "บันทึกแล้ว — การขายยังมีภาษี",
      "retransmit": "ตั้งคิวส่งใหม่แล้ว",
      "resend": "กำลังส่งการแก้ไข",
      "write_off": "ปิดแล้ว",
      "refund": "ส่งการคืนเงินแล้ว"
    },
    "refund_change": "เปลี่ยนวิธีคืนเงิน",
    "wait_sending": "ยังไม่ได้ส่ง 購入記録情報 — ส่งก่อน แล้วจึงบันทึกผลศุลกากร"
  },
  "customs_dialog": {
    "confirmed_title": "ศุลกากรยืนยันแล้ว?",
    "confirmed_desc": "ศุลกากรยืนยันว่านักท่องเที่ยวนำสินค้าออกนอกญี่ปุ่นแล้ว",
    "denied_title": "ไม่ปลอดภาษี?",
    "denied_desc": "ศุลกากรไม่ยืนยัน — การขายยังมีภาษี",
    "checked_at": "ตรวจเมื่อ",
    "ref": "เลขอ้างอิง (ไม่บังคับ)",
    "reason": "เหตุผล",
    "checked_at_invalid": "วันที่ตรวจต้องไม่ก่อนวันที่ซื้อ และไม่เกินกำหนด"
  },
  "resend": {
    "title": "แก้หลังคืนสินค้า (洗替)",
    "desc": "ยกเลิก 購入記録情報 ที่ส่งไปแล้ว แล้วส่งสินค้าที่เหลือใหม่",
    "keep": "สินค้าที่นักท่องเที่ยวเก็บไว้",
    "partial": "ส่งสินค้าที่ติ๊กใหม่",
    "full": "ไม่ได้ติ๊ก — ยกเลิกทั้งการขาย",
    "reason": "เหตุผล (ไม่บังคับ)",
    "submit": "ส่งการแก้ไข"
  },
  "write_off": {
    "title": "ปิดโดยไม่คืนเงิน?",
    "consequence": "ภาษีอยู่กับร้านและลงบัญชีเป็น 雑益 ใช้เฉพาะเมื่อติดต่อนักท่องเที่ยวไม่ได้"
  },
  "refund_dialog": {
    "title": "บันทึกการคืนภาษี",
    "desc": "เลือกวิธีคืนภาษีให้นักท่องเที่ยว",
    "amount": "ภาษีที่ต้องคืน:",
    "method": "วิธี",
    "bank_desc": "ร้านโอนเงินเข้าบัญชีธนาคารของนักท่องเที่ยว",
    "cash_agent_desc": "ตัวแทนมอบเงินสดให้นักท่องเที่ยว",
    "agent_desc": "บริษัทรับคืนภาษีจ่ายให้นักท่องเที่ยว",
    "bank_on_file": "มีข้อมูลบัญชีของนักท่องเที่ยวแล้ว",
    "bank_name": "ธนาคาร",
    "branch_name": "สาขา",
    "account_type": "ประเภทบัญชี",
    "futsu": "ออมทรัพย์ (普通)",
    "toza": "กระแสรายวัน (当座)",
    "account_number": "เลขบัญชี / IBAN",
    "account_name": "ชื่อบัญชี",
    "swift": "รหัส SWIFT",
    "bank_missing": "กรอกข้อมูลบัญชีของนักท่องเที่ยวก่อน",
    "bank_needs_kyc": "กรอกข้อมูลบัญชีได้เฉพาะพนักงานที่มีสิทธิ์ตรวจบัตร",
    "next": "ถัดไป",
    "confirm_title": "คืนภาษีไหม?",
    "confirm": "คืนภาษีให้นักท่องเที่ยวด้วย {{method}} บันทึกในประวัติ",
    "confirm_button": "คืนเงิน"
  },
  "export_files": {
    "open": "ไฟล์สำหรับสำนักงานภาษี",
    "title": "ไฟล์ 購入記録情報",
    "desc": "ระหว่างยังไม่เชื่อมกับสำนักงานภาษี รวมการขายของช่วงเวลาเป็นไฟล์เพื่ออัปโหลด",
    "from": "ตั้งแต่",
    "to": "ถึง",
    "version": "รูปแบบไฟล์",
    "version_help": "การขายแบบ リファンド方式 ใช้รูปแบบใหม่ ส่วนการขายก่อนหน้านั้นใช้รูปแบบเดิม",
    "version_v2": "ก่อน リファンド方式",
    "version_v3": "リファンド方式",
    "make": "สร้างไฟล์",
    "made": "สร้างไฟล์แล้ว: {{count}} การขาย",
    "made_list": "ไฟล์ที่สร้างแล้ว",
    "none": "ยังไม่มีไฟล์",
    "count_other": "{{count}} การขาย",
    "status_exported": "ยังไม่ส่ง",
    "status_submitted": "ส่งแล้ว",
    "file_csv": "ไฟล์ตาราง",
    "file_json": "ไฟล์ข้อมูล",
    "file_manifest": "รายการไฟล์พร้อมค่าตรวจสอบ",
    "reference": "เลขรับเรื่องของสำนักงานภาษี",
    "mark": "ทำเครื่องหมายว่าส่งแล้ว",
    "marked": "บันทึกว่าส่งแล้ว",
    "submitted_on": "ส่งเมื่อ"
  },
  "customs_import": {
    "open": "นำเข้าผลศุลกากรจากไฟล์",
    "title": "นำเข้าผลศุลกากรจากไฟล์",
    "desc": "ตรวจไฟล์ก่อน — ยังไม่มีอะไรเปลี่ยนจนกว่าจะกดนำเข้า",
    "columns": "คอลัมน์: เลขติดตามหรือเลขส่ง, ผล (confirmed / denied), วันที่ตรวจ, เลขอ้างอิง",
    "choose": "เลือกไฟล์",
    "checking": "กำลังตรวจไฟล์…",
    "summary": "นำเข้าได้ {{ok}} จาก {{total}} บรรทัด",
    "line": "บรรทัด",
    "record": "การขาย",
    "result": "ผล",
    "outcome": "ตรวจ",
    "apply_other": "นำเข้า {{count}} บรรทัด",
    "applied_other": "อัปเดต {{count}} การขายแล้ว",
    "outcomes": {
      "ok": "OK",
      "not_found": "ไม่พบการขาย",
      "already_final": "ตัดสินแล้ว",
      "not_applicable": "ไม่ใช่การขายแบบ リファンド方式",
      "not_transmitted": "ยังไม่ได้ส่ง",
      "duplicate": "ซ้ำในไฟล์",
      "invalid": "อ่านบรรทัดไม่ได้",
      "after_deadline": "หลังกำหนด"
    }
  },
  "report": {
    "title": "รายงานขายปลอดภาษีรายเดือน",
    "intro": "การขายปลอดภาษีของหนึ่งเดือนตามเวลาญี่ปุ่น — สำหรับบัญชีและนักบัญชี",
    "month": "เดือน",
    "previous": "เดือนก่อน",
    "next": "เดือนถัดไป",
    "of_month": "เดือน {{month}}",
    "csv": "ดาวน์โหลด (CSV)",
    "pdf": "ดาวน์โหลด (PDF)",
    "pdf_busy": "กำลังสร้าง PDF…",
    "pdf_after_month": "PDF ของเดือนทำได้ตั้งแต่วันที่ 1 ของเดือนถัดไป (เวลาญี่ปุ่น) — ก่อนหน้านั้นตัวเลขยังเปลี่ยนอยู่ ระหว่างนี้ใช้ CSV หรือหน้าจอนี้แทน",
    "pdf_ready": "บันทึก PDF {{number}} แล้ว",
    "pdf_ready_updated": "ตัวเลขเปลี่ยน จึงสร้าง PDF ฉบับใหม่ (ฉบับที่ {{version}}) : {{number}}",
    "count_other": "{{count}} การขาย",
    "tax": "ภาษี",
    "incl": "รวมภาษี",
    "journal_moved": "ย้ายจากมีภาษีเป็นปลอดภาษี (ศุลกากรยืนยัน)",
    "refunded": "คืนแล้ว",
    "outstanding": "ยังค้างคืน",
    "expired": "ยังมีภาษี (หมดเวลา)",
    "written_off": "ปิดโดยไม่คืน (雑益)",
    "late": "ส่งช้า",
    "by_status": "การขายตามสถานะ",
    "unsubmitted": "ไฟล์ที่ยังไม่ส่ง",
    "open_files": "เปิดไฟล์",
    "rows": "การขาย",
    "disclaimer": "ตัวช่วยสำหรับบัญชี — ตัวเลขยื่นภาษีให้ 税理士 ยืนยัน"
  },
  "evidence": {
    "title": "หลักฐานส่งออก (輸出免税)",
    "page_title": "หลักฐานส่งออก",
    "page_intro": "เก็บเอกสารเหล่านี้เพื่อให้ออเดอร์ยังปลอดภาษี เก็บไว้ 7 ปี",
    "status": {
      "not_required": "ไม่ต้องใช้",
      "missing": "ยังไม่มีหลักฐาน",
      "partial": "หลักฐานขาดบางส่วน",
      "complete": "เก็บหลักฐานครบ"
    },
    "ship_to": "ส่งไปที่",
    "declared": "มูลค่าที่แจ้ง",
    "paid_by": "จ่ายด้วย",
    "shipped": "ส่งเมื่อ",
    "payment_class": {
      "cash": "เงินสด",
      "traceable": "บัตรหรือโอน",
      "unknown": "ไม่ทราบ"
    },
    "not_required": {
      "settings_evidence_not_required": "การตั้งค่าภาษีบอกว่าไม่ต้องเก็บหลักฐาน",
      "order_cancelled": "ออเดอร์ถูกยกเลิก",
      "picked_up": "รับที่ร้าน — เป็นการขายในญี่ปุ่น",
      "other": "ออเดอร์นี้ไม่ต้องมีหลักฐานส่งออก"
    },
    "warning": {
      "RECIPIENT_DAY_TOTAL_OVER_LIMIT": "ผู้รับคนเดียวกันได้รับ {{total}} วันนี้ — ต้องมีใบอนุญาตส่งออก (輸出許可書)",
      "domestic_address": "ที่อยู่อยู่ในญี่ปุ่น (บริษัทส่งต่อ?) — ไม่ใช่การส่งออก",
      "other": "ตรวจหลักฐานของออเดอร์นี้"
    },
    "checklist": "หลักฐานที่ต้องเก็บ",
    "kind": {
      "carrier_record": "บันทึกรับฝากไปรษณีย์ (引受)",
      "shipping_slip_copy": "สำเนาใบส่ง (伝票控え)",
      "export_permit": "ใบอนุญาตส่งออก (輸出許可書)",
      "import_permit_equivalent": "หลักฐานนำเข้าที่ประเทศปลายทาง"
    },
    "kind_help": {
      "carrier_record": "เพิ่มเองเมื่อส่งกล่องพร้อมเลขติดตาม",
      "shipping_slip_copy": "รูปสำเนาใบส่งส่วนของลูกค้า",
      "export_permit": "ต้องมีเมื่อเกินเพดานไปรษณีย์ หรือขนส่งเอกชนแจ้งศุลกากร",
      "import_permit_equivalent": "ต้องมีเมื่อพิสูจน์ผู้จ่ายไม่ได้ (เงินสด)"
    },
    "still_missing": "ยังขาด",
    "kept": "เก็บแล้ว",
    "file_kept": "เก็บไฟล์แล้ว",
    "from_shipment": "จากการส่ง",
    "remove": "ลบ",
    "remove_aria": "ลบ {{kind}}",
    "remove_title": "ลบหลักฐานนี้ไหม?",
    "remove_consequence": "ออเดอร์อาจเสียหลักฐานปลอดภาษี ลบได้ภายใน 24 ชั่วโมงหลังเพิ่มเท่านั้น",
    "removed": "ลบแล้ว",
    "add_photo": "รูปหรือ PDF ของ {{kind}}",
    "type_number": "พิมพ์เลขแทน",
    "reference": "เลขบนเอกสาร",
    "save_reference": "บันทึก",
    "added": "เก็บหลักฐานแล้ว",
    "now_complete": "เก็บหลักฐานครบแล้ว — ออเดอร์สมบูรณ์",
    "carrier_auto": "จะมาเองเมื่อทำเครื่องหมายส่งแล้วพร้อมเลขติดตาม",
    "invoice_hint": "Commercial invoice พิมพ์จากเอกสารของออเดอร์",
    "open_order": "เปิดออเดอร์",
    "retention": "เก็บ 7 ปีในที่เก็บเอกสารของร้าน (電帳法)"
  },
  "queue": {
    "title": "หลักฐานส่งออกที่ต้องเพิ่ม",
    "intro": "ออเดอร์ต่างประเทศที่หลักฐานยังไม่ครบ — กล่องที่ส่งนานสุดก่อน เกิน 30 วันเป็นสีแดง",
    "tab_open": "ยังขาดหลักฐาน",
    "tab_complete": "ครบแล้ว",
    "order": "ออเดอร์",
    "status": "หลักฐาน",
    "missing": "ยังขาด",
    "age_other": "{{count}} วันที่แล้ว",
    "empty": "เก็บหลักฐานส่งออกครบทุกออเดอร์แล้ว",
    "empty_complete": "ยังไม่มีออเดอร์ที่ครบ",
    "drawer_title": "หลักฐานของ {{number}}"
  },
  "documents": {
    "title": "ค้นหาเอกสาร (電帳法)",
    "intro": "ใบเสร็จ ใบกำกับ และใบสรุปยอดทุกใบที่ร้านออกถูกเก็บไว้ที่นี่ 7 ปี ค้นด้วยวันที่ ยอดเงิน และชื่อลูกค้า (ใช้ร่วมกันได้) แล้วดาวน์โหลดไฟล์ที่เก็บไว้",
    "form_label": "ค้นหาเอกสาร",
    "date": "วันที่ซื้อขาย (取引年月日)",
    "date_from": "ตั้งแต่วันที่",
    "date_to": "ถึงวันที่",
    "amount": "ยอดเงิน (取引金額)",
    "amount_min": "ตั้งแต่",
    "amount_max": "ถึง",
    "amount_hint": "จำนวนเยนเต็ม",
    "counterparty": "ลูกค้าหรือผู้ฝากขาย (取引先)",
    "counterparty_placeholder": "พิมพ์บางส่วนของชื่อก็ได้",
    "number": "เลขที่เอกสาร",
    "number_placeholder": "เช่น R-2026-000123",
    "search": "ค้นหา",
    "clear": "ล้าง",
    "problem": {
      "dates_reversed": "วันที่เริ่มอยู่หลังวันที่สิ้นสุด",
      "amounts_reversed": "ยอดเงินต่ำสุดมากกว่ายอดสูงสุด"
    },
    "found_other": "{{count}} เอกสาร",
    "total": "รวม",
    "conditions_other": "ค้นด้วย {{count}} เงื่อนไข",
    "none": "ไม่พบเอกสารที่ตรงกัน",
    "none_hint": "ลองขยายช่วงวันที่หรือลดเงื่อนไข",
    "col": {
      "date": "วันที่",
      "kind": "ประเภท",
      "number": "เลขที่",
      "counterparty": "ลูกค้า / ผู้ฝากขาย",
      "amount": "ยอดเงิน",
      "file": "ไฟล์"
    },
    "version": "ฉบับที่ {{version}}",
    "replaced": "มีฉบับใหม่แทนแล้ว",
    "hold": "เก็บนานขึ้น",
    "open_source": "เปิดรายการขาย",
    "download": "ดาวน์โหลด {{number}} (PDF)",
    "not_ready": "กำลังสร้าง…",
    "pdf_saved": "บันทึก {{number}} แล้ว",
    "csv": "ดาวน์โหลดรายการ (CSV)",
    "more": "แสดงเพิ่ม",
    "kept": "เป็นไฟล์ที่ร้านออกจริง ไม่มีการแก้ไข การแก้ไขจะเป็นฉบับใหม่ที่อ้างถึงฉบับเดิม",
    "types": {
      "ryoshusho": "領収書 (ใบเสร็จ)",
      "kani_invoice": "適格簡易請求書 (ใบกำกับอย่างย่อ)",
      "tekikaku_invoice": "適格請求書 (ใบกำกับมีชื่อผู้ซื้อ)",
      "henkan_invoice": "返還インボイス (ใบลดหนี้)",
      "refund_note": "ใบแจ้งคืนเงิน",
      "commercial_invoice": "Commercial invoice (ส่งออก)",
      "customs_declaration": "ใบศุลกากร (CN22/CN23)",
      "packing_slip": "納品書 (ใบส่งของ)",
      "tax_free_slip": "บันทึกขายปลอดภาษี (免税)",
      "taxfree_explanation": "คำอธิบายปลอดภาษี (免税)",
      "refund_evidence": "หลักฐานคืนภาษี",
      "kaitori_meisai": "買取明細書 (ใบรับซื้อ)",
      "itaku_keiyaku": "委託契約書 (สัญญาฝากขาย)",
      "seisan_sho": "精算書 (ใบสรุปยอดผู้ฝากขาย)",
      "z_report": "日計表 (สรุปยอดประจำวัน)",
      "kobutsu_style15": "古物台帳 (様式第15号 รับเข้า)",
      "kobutsu_style16": "古物台帳 (様式第16号 จ่ายออก)",
      "taxfree_monthly_report": "รายงานปลอดภาษีรายเดือน",
      "supplier_invoice": "仕入明細書 (ใบสรุปการซื้อ)",
      "layaway_deposit_receipt": "預り証 (ใบรับมัดจำ)"
    }
  }
}
